import React, { Fragment, useEffect, useState } from 'react';
import { H2, H3, Image } from '../../../../AbstractElements';
import { Col, Row } from 'reactstrap';
import { Address, CancelOrders, PhoneNumber, PostalCode, Product, ShippingTo } from '../../../../Constant';
import Frame from '../../../../assets/images/RewardFrame.svg';
import { getTrackInvoice } from '../../../../CommonUrl';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';
import Popup from '../../../Common/Popup/popup';
import CancelOrderForm from './CancelOrder';

const ProductReward = ({ product, api, order_id }) => {
    const addressDetail = api?.shipping_info?.shipping_address;
    const [isOpenAdd, setisOpenAdd] = useState(false);
    const [isCancelled, setIsCancelled] = useState('');
    const [steps, setSteps] = useState([
        { label: "Order Placed", status: "pending", completed: false, date: null },
        { label: "Processing", status: "processing", completed: false, date: null },
        { label: "Shipped", status: "shipped", completed: false, date: null },
        { label: "Delivered", status: "delivered", completed: false, date: null },
    ]);
    const [isCancel, setIscancel] = useState(false)


    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        const response = await getClientUrlDataToken(getTrackInvoice + `?order_id=${order_id}`);
        const data = response?.data || [];
        const hasCancelled = data.some(item => item.status === 'cancelled');
        setIsCancelled(hasCancelled);

        const baseSteps = [
            { label: "Order Placed", status: "pending", completed: false, date: null },
            { label: "Processing", status: "processing", completed: false, date: null },
            { label: "Shipped", status: "shipped", completed: false, date: null },
            { label: "Delivered", status: "delivered", completed: false, date: null },
        ];

        let maxIndex = -1;
        data.forEach((item) => {
            const stepIndex = baseSteps.findIndex(step => step.status === item.status);
            if (stepIndex !== -1) {
                baseSteps[stepIndex].date = item.created_on;
                if (stepIndex > maxIndex) {
                    maxIndex = stepIndex;
                }
            }
        });

        for (let i = 0; i <= maxIndex; i++) {
            baseSteps[i].completed = true;
        }
        const cancelButton = baseSteps?.find((item) => item?.status === 'pending' && item?.completed === true)
        if (cancelButton) {
            setIscancel(true)
        }
        setSteps(baseSteps);
    };

    const handleModalAdd = () => {
        setisOpenAdd(!isOpenAdd);
    };

    return (
        <Fragment>
            <Popup isOpen={isOpenAdd} toggler={handleModalAdd} title={CancelOrders}>
                <CancelOrderForm setisOpenAdd={setisOpenAdd} order_id={order_id} />
            </Popup>
            <Row>
                <Col xl="6" sm="12">
                    <div className="checkout-details">
                        <div className="order-box">
                            <div className="checkbox-title">
                                <H2>{Product}</H2>
                            </div>
                            <div className="title-box">
                                {
                                    product && product.map((item) => {
                                        if (item.name === "Delivery charges") return null;

                                        return (
                                            <div className="d-flex align-items-center justify-content-between gap-3 p-2" key={item.id || item.name}>
                                                <Image
                                                    attrImage={{
                                                        className: 'img-fluid img-90',
                                                        src: item.item_image,
                                                        alt: item.item_name
                                                    }}
                                                />

                                                <div className="ms-3" style={{ flex: 1 }}>
                                                    <div>
                                                        <h3 className="mb-1">{item.name}</h3>
                                                        {item?.attribute_list &&
                                                            Object.entries(item?.attribute_list).map(([key, value]) => (
                                                                <div key={key} style={{ fontSize: '14px', color: '#666' }}>
                                                                    {key}: {value}
                                                                </div>
                                                            ))}
                                                        <p className="mb-0 text-muted"><b>Quantity: {item.quantity}</b></p>
                                                    </div>
                                                </div>

                                                <div className="text-end">
                                                    <h4 className="mb-0">${item.sub_total}</h4>
                                                </div>
                                            </div>
                                        );
                                    })
                                }

                            </div>
                            <div className="checkbox-title mt-3">
                                <H2>{ShippingTo}</H2>
                                <div>
                                    <h3 className="mb-1">{api?.shipping_info?.shipping_address?.recipient_name}</h3>
                                    <p><b>{Address}: </b>{addressDetail?.address}, {addressDetail?.street}, {addressDetail?.city}, {addressDetail?.country}</p>
                                    <p><b>{PostalCode}: </b>{addressDetail?.postal_code}</p>
                                    <p><b>{Address} Type: </b>{addressDetail?.address_type}</p>
                                    <p><b>{PhoneNumber}: </b>{addressDetail?.phone}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
                <Col xl="6" sm="12">
                    <div style={{
                        position: 'relative',
                        backgroundImage: `url(${Frame})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'left center',
                        borderRadius: '15px',
                        padding: '20px 30px',
                        height: '160px',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <div style={{ marginLeft: 'auto' }}>
                            <h4 style={{ margin: 0 }}>You earned {api?.reward_points} reward points!</h4>
                            <p style={{ margin: 0, fontSize: '14px' }}>To know more check Reward Points</p>
                        </div>
                    </div>

                    <div className="track-order">
                        <H2>Track Order</H2>
                        <div className="steps">
                            {isCancelled === true ? (
                                <div className="cancelled-status">
                                    <h4 style={{ color: "red" }}>Cancelled</h4>
                                </div>
                            ) : (
                                <div className="steps">
                                    {steps.map((step, idx) => (
                                        <div key={idx} className="step">
                                            <div className={`circle ${step.completed ? "done" : ""}`}></div>
                                            <div className="info">
                                                <p>
                                                    {step.label}
                                                    {step.date && <span className="date"> on {step.date}</span>}
                                                </p>
                                            </div>
                                            {idx !== steps.length - 1 && <div className="line" />}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        {steps?.[0]?.status === "pending" &&
                            steps?.[0]?.completed === true &&
                            steps?.slice(1).every(step => !step.completed) && (
                                <button className="cancel-btn" onClick={handleModalAdd}>
                                    Cancel order
                                </button>
                            )}
                    </div>
                </Col>
            </Row>
        </Fragment >
    )
}

export default ProductReward